import React from "react";
import { Resizable } from "re-resizable";
import Z from "../Components/icons/z.svg";
import Modal from "../Components/Modal/Modal";
import * as Action from "../Store/Action";
import Data from "../Page/Data/Data";
import { connect } from "react-redux";
import data from "../Components/icons/data.svg";
import activity from "../Components/icons/activity-new.svg";
import activity_dark from "../Components/icons/activity-new-dark.svg";
import task_dark from "../Components/icons/task_dark.svg";
import data_dark from "../Components/icons/data_dark.svg";
import control from "../Components/icons/control.svg";
import control_dark from "../Components/icons/control-dark.svg";
import manage from "../Components/icons/manage.svg";
import manage_dark from "../Components/icons/manage_dark.svg";
import plot from "../Components/icons/plot.svg";
import setting from "../Components/icons/settings.svg";
import task from "../Components/icons/task.svg";
import NewTask from "../Page/NewTask/NewTask";
import EditTask from "../Page/Edit/Edit";
import weather from "../Components/icons/weather.svg";
import weather_dark from "../Components/icons/weather_dark.svg";
import rabit from "../Components/icons/rabbit.svg";
import turtle from "../Components/icons/turtle.svg";
import rabit_white from "../Components/icons/rabbit_white.svg";
import turtle_white from "../Components/icons/turtle_white.svg";
import plot_dark from "../Components/icons/plot_dark.svg";
import Fab from "../Components/FAB/Fab";
import Select from "react-select";
import Zone from "../Model/Zone";
import Plot from "../Model/Plot";
import Error from "../Components/Error/Error";
import { v4 } from "uuid"
import Tracktor from "../Components/Tracktor/Tracktor";
import Implement from "../Components/Implement/Implement";
import AllTask from "../Page/AllTask/AllTask"
import nozzle from "./nozzle.svg";
import nozzle_dark from "./nozzle_dark.svg";
import styles from "./Layout.module.scss";
import {Switch,Route,withRouter} from "react-router-dom";
import { loadBing, zoomOut, zoomIn,pan,refetch } from "./utility";
import Battery from "../Components/Battery/Battery";
import CropLand from "../Model/Cropland";
import {statesplit} from "./state";
import Zoom from "../Components/Zoom/Zoom";
import FullScreenButton from "../Components/FullScreen/FullScreen";
import StopButton from "../Components/Stop/Stop";
import Navigation from "../Components/Navigation/Navigation";
class Layout extends React.PureComponent {
    constructor() {
        super()
        this.map = null
        this.Microsoft = null
        this.clientX = 0;
    }
    state = {
        ...statesplit
    }
    toggleTracktor = () => {
        this.setState({
            implementModel: false,
            tracktorModel: !this.state.tracktorModel
        })
    }
    toggleImplement = () => {
        this.setState({
            tracktorModel: false,
            implementModel: !this.state.implementModel
        })
    }
    changeFlexCropland = (info)=>{
        this.setState({
            flexCroplandName:info.label
        })
    }
    changeFlexMars = (info)=>{
        this.setState({
            flexMars:info.label
        })
    }

    getImplementName = ()=>{
        if(this.state.flexCroplandName !=="" && this.state.flexMars!==""){
            for(var i=0;i<this.props.tasks.length;i++){
               if(this.props.tasks[i].status === this.state.flexCroplandName 
                && this.props.tasks[i].tracktername === this.state.flexMars){
                    return this.props.tasks[i].implementName
                }
            }
            return "Rotary Tiller"
        }else{
            return "Rotary Tiller"
        }
    }
    resetInfo = () => {
        this.setState({
            implementName: null,
            implementSrc: null,
            tracktorName: null,
            tracktorColor: null,
        })
    }
    selectImplement = (name, src) => {
        this.setState({
            implementName: name,
            implementModel: false,
            implementSrc: src
        })
    }
    selectTracktor = (name, batteryColor) => {
        this.setState({
            tracktorName: name,
            tracktorModel: false,
            tracktorColor: batteryColor
        })
    }
    zoomHoverTrue = ()=>{
        this.setState({ isHover: true })
    }

    zoomLeaveTrue = ()=>{
        this.setState({ isHover: false })
    }
    componentDidUpdate = (previous, next) => {
        if(next.fab === "DELETE"){
            refetch(this);
            this.manager.clear()
        }
    }
    pick_fab = (name) => {
        if (name !== this.state.fab) {
            this.setState({
                fab: name
            }, () => {
                this.map.setOptions({
                    disablePanning: true
                })
            })
        } else {
            this.setState({
                fab: ""
            }, () => {
                this.map.setOptions({
                    disablePanning: false
                })
            })
        }
    }
    focusZone = (info) => {
        const self = this;
        const zone = self.props.zones[info.zindex]
        const plot = zone.plots[info.pindex]
        const cropland = plot.cropsland[info.cindex];
        self.Microsoft.Maps.loadModule("Microsoft.Maps.GeoJson", function () {
            const polygon = self.Microsoft.Maps.GeoJson.read(cropland["polygon"])
            self.Microsoft.Maps.loadModule("Microsoft.Maps.SpatialMath", function () {
                const centroid = self.Microsoft.Maps.SpatialMath.Geometry.centroid(polygon)
                self.map.setView({ center: centroid, zoom: 20 });
            })
        })
    }
    changeMapStyle = () => {
        if (this.state.mapview === 0) {
            this.map.setView({
                mapTypeId: this.Microsoft.Maps.MapTypeId.road,
                zoom: 17
            });
            this.setState({
                mapview: 1
            })
        } else {
            this.map.setView({
                mapTypeId: this.Microsoft.Maps.MapTypeId.aerial,
                zoom: 17
            });
            this.setState({
                mapview: 0
            })
        }
    }
    zoomControl = () => {
        zoomIn(this)
    }
    openFullscreen = () => {
        if(!this.state.fullscreen){
            var elem = document.documentElement;
            if (elem.requestFullscreen) {
                elem.requestFullscreen().then(_=>{
                    this.setState({
                        fullscreen:true
                    })
                })
            } else if (elem.webkitRequestFullscreen) { 
                elem.webkitRequestFullscreen();
                this.setState({
                    fullscreen:true
                })
            } else if (elem.msRequestFullscreen) { 
                elem.msRequestFullscreen();
                this.setState({
                    fullscreen:true
                })
            }
        }else{
            if (document.exitFullscreen) {
                document.exitFullscreen().then(_=>{
                    this.setState({
                        fullscreen:false
                    })
                });
              } else if (document.webkitExitFullscreen) { 
                document.webkitExitFullscreen();
                this.setState({
                    fullscreen:false
                })
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
                this.setState({
                    fullscreen:false
                })
              }
        }   
    }
    zoomOutControl = () => {
        zoomOut(this)
    }
    componentDidMount = () => {
        const self = this;
        document.addEventListener("fullscreenchange", function() {
            if(self.resizable){
                self.resizable.updateSize({height: "100%", width: 340 });
            }
        }); 
        document.addEventListener("mozfullscreenchange", function() {
            if(self.resizable){
                self.resizable.updateSize({height: "100%", width: 340 });
            }
          });
          document.addEventListener("webkitfullscreenchange", function() {
            if(self.resizable){
                self.resizable.updateSize({height: "100%", width: 340 });
            }
          });
          document.addEventListener("msfullscreenchange", function() {
            if(self.resizable){
                self.resizable.updateSize({height: "100%", width: 340 });
            }
          }); 
        if ('onorientationchange' in window) {
            window.addEventListener("orientationchange", function(e) {
                if(self.resizable){
                    self.resizable.updateSize({height: "100%", width: 340 });
                }  
            })
        }
       loadBing(this)   
    }
    onSuccess = (plotname) => {
        const self = this;
        var polygon = new this.Microsoft.Maps.Polygon(this.state.polygon, {
            fillColor: self.state.fab !== "CROPLAND" ? "rgba(1, 1, 1, 0)" : this.state.fillColor,
            strokeColor: self.state.fab !== "CROPLAND" ? "#ffffff" : this.state.color,
            strokeThickness: self.state.fab !== "CROPLAND" ? 2 : 4
        });
        const id = v4()
        polygon["id"] = id;
        var area = self.Microsoft.Maps.SpatialMath.Geometry.area(polygon, self.Microsoft.Maps.SpatialMath.AreaUnits.Acres);
        area = Math.round(area * 100) / 100;
        this.Microsoft.Maps.loadModule("Microsoft.Maps.SpatialMath", function () {
            if (self.state.fab) {
                const centroid = self.Microsoft.Maps.SpatialMath.Geometry.centroid(polygon)
                const deg = self.Microsoft.Maps.SpatialMath.toDegMinSec(centroid)
                const ob = self.convertDMStoObject(deg)
                var title = "";
                if (self.state.fab === "ZONE") {
                    title = "Zone"
                } else if (self.state.fab === "PLOT") {
                    title = "Plot"
                } else {
                    title = "Cropland"
                }
                const pushpin = new self.Microsoft.Maps.Pushpin(centroid, {
                    title: `${title} (${plotname})`,
                    subTitle: `${area} acre | ${ob["N"]} N  ${ob["E"]} E`,
                    color: self.state.color
                });
                self.Microsoft.Maps.loadModule("Microsoft.Maps.GeoJson", function () {
                    if (self.state.fab === "ZONE") {
                        self.map.entities.push(polygon);
                        self.map.entities.push(pushpin);
                        const zone = new Zone(id, plotname, "rgba(0,0,0,0)", self.state.color, self.Microsoft.Maps.GeoJson.write(polygon), area, [])
                        self.props.addZone(zone)
                    } else if (self.state.fab === "PLOT") {
                        var matchedIndex = null;
                        for (var key = 0; key < self.props.zones.length; key++) {
                            const z = self.props.zones[key]
                            const p = self.Microsoft.Maps.GeoJson.read(z["polygon"]) //polygon
                            const matched = self.Microsoft.Maps.SpatialMath.Geometry.contains(p, polygon)
                            if (matched) {
                                matchedIndex = key;
                                break
                            }
                        }
                        if (matchedIndex !== null) {
                            self.map.entities.push(pushpin);
                            self.map.entities.push(polygon);
                            const mplot = new Plot(id, plotname, "rgba(255,0,0,0)", self.state.color, self.Microsoft.Maps.GeoJson.write(polygon), [], area)
                            self.props.addPlot(mplot, matchedIndex)
                        } else {
                            self.setState({
                                showErrorModal: true,
                                errorMessage: "please draw plot inside zone"
                            })
                        }
                    } else {
                        var zoneIndex = null;
                        var plotIndex = null;
                        for (var k = 0; k < self.props.zones.length; k++) {
                            const currentPlot = self.props.zones[k]        
                            for (var i = 0; i < currentPlot.plots.length; i++) {
                                const plot = currentPlot.plots[i]
                                const matched = self.Microsoft.Maps.SpatialMath.Geometry.contains(self.Microsoft.Maps.GeoJson.read(plot["polygon"]), polygon)
                                if (matched) {
                                    zoneIndex = k;
                                    plotIndex = i;
                                    break
                                }
                            }
                            if (zoneIndex !== null && plotIndex !== null) {
                                break
                            }
                        }
                        if (zoneIndex === null || plotIndex === null) {
                            self.setState({
                                showErrorModal: true,
                                errorMessage: "please draw cropland inside plot"
                            })
                        } else {
                            const cropland = new CropLand(id, plotname, self.Microsoft.Maps.GeoJson.write(polygon), self.state.color, self.state.color, self.state.fillColor, area)
                            self.props.addCropland(cropland, zoneIndex, plotIndex)
                            self.map.entities.push(pushpin);
                            self.map.entities.push(polygon);
                        }
                    }
                    self.setState({
                        showModal: false
                    })
                    self.setState({
                        polygon: null,
                        color: null,
                        fillColor: null
                    })
                })
            }
        })
    }
    onDiscard = () => {
        this.setState({
            showModal: false
        })
    }
    onDiscardError = () => {
        this.setState({
            showErrorModal: false
        })
    }
    toggle_fab = () => {
        this.setState({
            fab_open: !this.state.fab_open
        })
    }
    convertDMStoObject = (dms) => {
        if (dms !== "") {
            const r = dms.split(" ")
            if (r.length === 8) {
                return {
                    "N": r[0] + r[1] + r[2].toString().split('.')[0],
                    "E": r[4] + r[5] + r[6].toString().split('.')[0],
                }
            }
            return null
        }
        return null
    }
    render() {
        const result = this.convertDMStoObject(this.state.dmsString)
        const tractor = []
        this.props.tasks.forEach(t => {
            tractor.push({ value: t.tracktername, label: t.tracktername })
        })
        const style1 = {
            control: (base, state) => ({
                ...base,
                border: "0 !important",
                boxShadow: "0 !important",
                "&:hover": {
                    border: "0 !important"
                },
                background: "none"
            }),
            singleValue: (provided) => ({
                ...provided,
                color: this.state.mapview ? 'white' : "black"
            })
        };
        const cropland = []
        const mars = []
        function containsObject(obj, list) {
            var x;
            for (x in list) {
                if (list[x]["label"]=== obj["label"]) {
                    return true;
                }
            }
        
            return false;
        }
        this.props.tasks.forEach(e=>{
            if(!containsObject({ value: e.status, label: e.status},cropland)){
                cropland.push({ value: e.status, label: e.status })
            }
        })

        this.props.tasks.forEach(e=>{
            if(!containsObject({value: e.tracktername, label: e.tracktername },mars)){
                mars.push({value: e.tracktername, label: e.tracktername })
            }
        })
        
        return (
            <div className="c-container">
                <div className="relative">
                    <Resizable
                       ref={c => { this.resizable = c; }}
                        defaultSize={{
                            width: 340,
                            height: window.innerHeight
                        }}
                        minWidth={340}
                        maxWidth={450}
                        className={`side_bar absolute ${!this.state.showContent ? 'auto_width' : ''}`}
                    >
                       
                        <div className={`side_icons ${!this.state.showContent ? 'side_icons_f_with' : ''}`}>
                         
                            <img height="28px" width="50%" alt="z" src={Z}></img>
              
                            <div className="hr"></div>
                            <div className={this.state.page === "PLOT" ? "bg_items" : ""}>
                                <div onClick={() => {
                                    this.setState({
                                        page: "PLOT"
                                    })
                                    this.props.history.push("/plot")
                                }} className="items">
                                    {this.state.page === "PLOT" ? <img src={plot_dark} alt="plot"></img> : <img src={plot} alt="plot"></img>}
                                    {
                                        this.state.page === "PLOT" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Plot</small>
                                    }
                                </div>
                            </div>
                            <div className={this.state.page === "DATA" ? "bg_items" : ""}>
                                <div onDoubleClick={
                                    () => {
                                        this.setState({
                                            showContent: !this.state.showContent
                                        })
                                    }
                                } onClick={() => {
                                    this.setState({
                                        page: "DATA"
                                    })
                                    this.props.history.push("/data")
                                }} className="items">
                                    {this.state.page === "DATA" ? <img src={data_dark} alt="data"></img> : <img src={data} alt="data"></img>}
                                    {
                                        this.state.page === "DATA" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Data</small>
                                    }
                                </div>
                            </div>
                            <div  className={this.state.page === "NEW_TASK" ? "bg_items" : ""}>
                                <div onDoubleClick={
                                    () => {
                                        this.setState({
                                            showContent: !this.state.showContent
                                        })
                                    }} onClick={() => {
                                        this.setState({
                                            page: "NEW_TASK"
                                        })
                                        this.props.history.push("/tasks")
                                    }} className="items">
                                    {this.state.page === "NEW_TASK" ? <img src={task_dark} alt="task"></img> : <img src={task} alt="task"></img>}
                                    {
                                        this.state.page === "NEW_TASK" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Task</small>
                                    }

                                </div>
                            </div>
                            <div onClick={() => {
                                this.setState({
                                    page: "CONTROL"
                                })
                                this.props.history.push("/control")
                            }} className={this.state.page === "CONTROL" ? "bg_items" : ""}>
                                <div className="items">
                                    {this.state.page === "CONTROL" ? <img src={control_dark} alt="CONTROL"></img> : <img src={control} alt="CONTROL"></img>}
                                    {
                                        this.state.page === "CONTROL" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Control</small>

                                    }
                                </div>
                            </div>
                            <div onClick={() => {
                                this.setState({
                                    page: "WEATHER"
                                })
                                this.props.history.push("/weather")
                            }} className={this.state.page === "WEATHER" ? "bg_items" : ""}>
                                <div className="items">
                                    {this.state.page === "WEATHER" ? <img src={weather_dark} alt="weather"></img> : <img src={weather} alt="weather"></img>}
                                    {
                                        this.state.page === "WEATHER" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Weather</small>

                                    }
                                </div>
                            </div>
                            <div onClick={() => {
                                this.setState({
                                    page: "MANAGE"
                                })
                                this.props.history.push("/manage")
                            }} className={this.state.page === "MANAGE" ? "bg_items" : ""}>
                                <div className="items">
                                    {this.state.page === "MANAGE" ? <img src={manage_dark} alt="MANAGE"></img> : <img src={manage} alt="MANAGE"></img>}
                                    {
                                        this.state.page === "MANAGE" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Manage</small>

                                    }
                                </div>
                            </div>
                            <div onClick={() => {
                                this.setState({
                                    page: "ACTIVITY"
                                })
                                this.props.history.push("/activity")
                            }} className={this.state.page === "ACTIVITY" ? "bg_items" : ""}>
                                <div className="items">
                                    {this.state.page === "ACTIVITY" ? <img src={activity_dark} alt="ACTIVITY"></img> : <img src={activity} alt="ACTIVITY"></img>}
                                    {
                                        this.state.page === "ACTIVITY" ? null : <small style={{ color: "#cccccc", textAlign: "center" }}>Activity</small>

                                    }
                                </div>
                            </div>
                            <div className="hr"></div>
                            <div className="items">
                                <img height="30px" alt="first" src={setting}></img>
                            </div>
                        </div>
                        <div ref={this.sideContent}  className={this.state.showContent?"side_icons_data":"hide_content"}>
                            <Switch>
                                <Route exact path="/tasks" render={()=>this.props.tasks.length > 0 ? <AllTask resetInfo={this.resetInfo} toggleImplement={this.toggleImplement} implementName={this.state.implementName} implementSrc={this.state.implementSrc} name={this.state.tracktorName} color={this.state.tracktorColor} toggleTracktor={this.toggleTracktor} focusZone={this.focusZone}></AllTask> : <NewTask toggleImplement={this.toggleImplement} resetInfo={this.resetInfo} implementName={this.state.implementName} implementSrc={this.state.implementSrc} name={this.state.tracktorName} color={this.state.tracktorColor} toggleTracktor={this.toggleTracktor} focusZone={this.focusZone} ></NewTask>}></Route>
                                <Route  exact path="/data" component={Data}></Route>
                                <Route exact path="/edit/:index" component={EditTask}></Route>
                                <Route  exact path="/control" render={()=><div></div>}></Route>
                                <Route  exact path="/plot" render={()=><div></div>}></Route>
                                <Route  exact path="/weather" render={()=><div></div>}></Route>
                                <Route  exact path="/manage" render={()=><div></div>}></Route>
                                <Route  exact path="/activity" render={()=><div></div>}></Route>
                            </Switch>
                        </div>
                    </Resizable>
                    <div oncontextmenu="return false;" className="absolute_1" id="map">
                        <div className="sidebar-arrows">
                            <div onClick={()=>{
                                const currentWidth = this.resizable.state.width;
                                if(currentWidth < 395){
                                    this.resizable.updateSize({height: "100%", width: currentWidth + 50 });
                                }
                               
                            }} className="right-arrow">
                                <i class="fas fa-arrow-right"></i>
                                <span className="sbexpand_tooltip">Sidebar Expand</span>
                            </div>
                            <div onClick={()=>{
                                  const currentWidth = this.resizable.state.width;
                                  if(currentWidth > 340){
                                      this.resizable.updateSize({height: "100%", width: currentWidth - 50 });
                                  }
                            }} className="left-arrow">
                                <i class="fas fa-arrow-left"></i>
                                <span className="sbshrink_tooltip">Sidebar Shrink</span>
                            </div>
                        </div>
                        <div className="farm_flex" onMouseOver={() => this.setState({ farmFlexHover: true })} onMouseLeave={() => this.setState({ farmFlexHover: false })}>
                            <div className={`farm_flex_select ${this.state.mapview ? 'bgi_blue' : 'bgi_white'}`}>
                                <Select onChange={this.changeFlexCropland} isSearchable={false} components={{
                                    IndicatorSeparator: () => null,
                                }} styles={style1} className="farm_name" options={Array.from(cropland)} />
                                <Select onChange={this.changeFlexMars}  isSearchable={false} components={{
                                    IndicatorSeparator: () => null
                                }} styles={style1} className="tractor_name" options={Array.from(mars)} />
                            </div>
                            <div className="rotatry">
                                <img src={this.state.mapview ? nozzle_dark : nozzle} alt="nozzle"></img>
                                <p style={{
                                    color: this.state.mapview ? "#071C48" : "white",
                                    marginLeft: "0.2rem",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                }}>{this.getImplementName()}</p>
                                <i style={{
                                    color: "#00bb61",
                                    marginLeft: "10px",
                                    fontSize: "5px"
                                }} class="fas fa-circle"></i>
                            </div>
                        </div>
                        <Navigation pan={(dir)=>pan.call(this,dir)}></Navigation>
                        <div onMouseOver={() => this.setState({ mapViewHover: true })} onMouseLeave={() => this.setState({ mapViewHover: false })}>
                            <div
                                onClick={()=>{
                                    this.setState({
                                        work_view:!this.state.work_view
                                    })
                                }}
                                style={{
                                    display: "flex",
                                    position: "absolute",
                                    zIndex: "1000",
                                    background: this.state.mapview ? this.state.mapViewHover ? "white" : "#071C48" : this.state.mapViewHover ? "#071C48" : "white",
                                    borderRadius: "30px",
                                    color: "white",
                                    left: "10px",
                                    bottom: "3%",
                                    cursor: "pointer",
                                    width:"auto",
                                    height: "40px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "2px",
                                    transition: "all 500ms"
                                }}>
                                <div
                                    style={{
                                        background:this.state.work_view && !this.state.mapViewHover && !this.state.mapview ?"#3e7aff":(this.state.work_view && this.state.mapViewHover && !this.state.mapview?"white":(this.state.work_view && !this.state.mapViewHover && this.state.mapview?"white":(this.state.work_view && this.state.mapViewHover && this.state.mapview?"#3e7aff":null))) ,
                                        color:  this.state.work_view && !this.state.mapViewHover && !this.state.mapview?"white":(this.state.work_view && !this.state.mapViewHover && this.state.mapview? "black":this.state.work_view && this.state.mapViewHover && !this.state.mapview?"black":this.state.work_view && !this.state.mapViewHover && !this.state.mapview?"black":!this.state.work_view && this.state.mapViewHover && !this.state.mapview?"white":this.state.work_view && !this.state.mapViewHover && this.state.mapview?"white":"black"),
                                        borderRadius: "100px",
                                        padding: "5px",
                                        fontSize: "12px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        height: "36px",
                                        width: "78px",
                                    }}>Work View</div>
                                <div style={{
                                    background:!this.state.work_view && !this.state.mapViewHover && !this.state.mapview ?"#3e7aff":(!this.state.work_view && this.state.mapViewHover && !this.state.mapview?"white":(!this.state.work_view && !this.state.mapViewHover && this.state.mapview?"white":(!this.state.work_view && this.state.mapViewHover && this.state.mapview?"#3e7aff":null))) ,
                                    color: !this.state.work_view && !this.state.mapViewHover && !this.state.mapview?"white":(!this.state.work_view && !this.state.mapViewHover && this.state.mapview? "black":!this.state.work_view && this.state.mapViewHover && !this.state.mapview?"black":this.state.work_view && !this.state.mapViewHover && !this.state.mapview?"black":this.state.work_view && this.state.mapViewHover && !this.state.mapview?"white":this.state.work_view && !this.state.mapViewHover && this.state.mapview?"white":"black"),
                                    padding: "5px",
                                    borderRadius: "100px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    height: "36px",
                                    width: "78px",
                                    fontSize: "12px"
                                }}>Map View</div>
                            </div>

                        </div>
                    </div>
            </div>
                    {this.state.tracktorModel ? <Tracktor toggleTracktor={this.toggleTracktor} selectTracktor={this.selectTracktor}></Tracktor> : null}
                    {this.state.implementModel ? <Implement toggleImplement={this.toggleImplement} selectImplement={this.selectImplement}></Implement> : null}
                    <Modal name={this.state.fab} show={this.state.showModal} onSave={this.onSuccess} onDiscard={this.onDiscard}></Modal>
                    <Error onDiscard={this.onDiscardError} show={this.state.showErrorModal} message={this.state.errorMessage}></Error>
                    <StopButton></StopButton>
                    <div className={styles.change_mapview}>
                        <div onClick={this.changeMapStyle} className={this.state.mapview ? "satellite" : "aerial"}>
                            <span className={styles.mapview_tooltip}>Change Map view</span>
                        </div>
                    </div>
                    <Zoom  zoomHoverTrue={this.zoomHoverTrue} zoomLeaveTrue={this.zoomLeaveTrue}   isHover={this.state.isHover} zoomControl={this.zoomControl}  zoomOutControl={this.zoomOutControl} mapview={this.state.mapview}></Zoom>
                    <FullScreenButton openFullscreen={this.openFullscreen}></FullScreenButton>
                    <div className={`speedControl ${this.state.mapview ? 'bg_blue' : 'bg_white'}`} onMouseOver={() => this.setState({ isRabitHover: true })} onMouseLeave={() => this.setState({ isRabitHover: false })}>
                        {
                            this.state.isRabitHover ? (
                                <React.Fragment>
                                    <img onClick={()=>{
                                        if(this.state.speed <= 44.8){
                                            this.setState({
                                                speed:(parseFloat(this.state.speed)+0.1).toFixed(1)
                                            })
                                        }
                                    }} src={this.state.mapview ? rabit : rabit_white} alt="rabit"></img>
                                    <p style={{
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        color: this.state.mapview ? "#071C48" : "#FFFFFF",
                                        opacity: this.state.mapview ? 0.6 : 1
                                    }}>2X</p>
                                    <img onClick={()=>{
                                        if(this.state.speed > 0.0){
                                            this.setState({
                                                speed:(parseFloat(this.state.speed) - 0.1).toFixed(1)
                                            })
                                        }
                                    }} src={this.state.mapview ? turtle : turtle_white} alt="turtle"></img>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <img src={this.state.mapview ? rabit_white : rabit} alt="rabit"></img>
                                    <p style={{
                                        fontSize: "14px",
                                        fontWeight: "400",
                                        color: this.state.mapview ? "#FFFFFF" : "#071C48",
                                        opacity: this.state.mapview ? 0.6 : 1
                                    }}>2X</p>
                                    <img src={this.state.mapview ? turtle_white : turtle} alt="turtle"></img>
                                </React.Fragment>
                            )
                        }
                    </div>
                    <div className={`coordinates ${this.state.mapview ? "text_grey_color" : "text_white_color"}`}>
                        <p>{result ? result["N"] + " N" : "47.40° N"}</p>
                        <p className="ml-4">{result ? result["E"] + " E" : "47.40° E"}</p>
                        <p className="ml-4">Eye {this.state.eye}</p>
                    </div>
                    <div className={`v__speed ${this.state.mapview ? "text_grey_color" : "text_white_color"}`}>
                        <div className={styles.tractor_speed}>
                            <span className={`${this.state.mapview ? "text_grey_color" : "text_white_color"}`} style={{
                                fontSize: "50px",
                                fontWeight: "500"
                            }}>{this.state.speed}</span>
                            <span className={`${this.state.mapview ? "text_grey_color" : "text_white_color"}`} style={{
                                fontSize: "20px"
                            }}> m/s</span>
                            <span className={styles.speed_tooltip}>Tractor Speed Indicator</span>
                        </div>
                    </div>
                    <div onMouseOver={() => this.setState({ fabHover: true })} onMouseLeave={() => this.setState({ fabHover: false })}>
                        <Fab mapView={this.state.mapview} lock={this.state.lock} hover={this.state.fabHover} fab={this.state.fab} pick_fab={this.pick_fab} fab_open={this.state.fab_open} toggle={this.toggle_fab}></Fab>
                    </div>
                    <Battery mapview={this.state.mapview}></Battery>
            </div>
        )
    }
}
const MapStateToProps = state => {
    return {
        zones: state.zones,
        tasks: state.tasks
    }
}
const MapDispatch = (dispatch) => {
    return {
        addZone: (data) => dispatch({ type: Action.ADD_ZONE, land: data }),
        addPlot: (plot, zindex) => dispatch({ type: Action.ADD_PLOT, plot, zindex }),
        addCropland: (crop, zindex, pindex) => dispatch({ type: Action.ADD_CROPLAND, crop, zindex, pindex }),
        deleteZone: (id) => dispatch({ type: Action.DELETE_ZONE, id }),
        deletePlot: (id, zindex) => dispatch({ type: Action.DELETE_PLOT, zindex, id }),
        deleteCropland: (id, zindex, pindex) => dispatch({ type: Action.DELETE_CROPLAND, zindex, pindex, id })
    }
}
export default connect(MapStateToProps, MapDispatch)(withRouter(Layout));




